import impactReportSvg from "../../../assets/impact-report.svg";

export default function ImpactEstimateReports() {
  return (
    <section className="secondary-page">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8 l0-section-text">
          <h1>Impact Estimate Reports</h1>
          <ul className="l0-list">
            <li>
              At the end of each certification level, every lab receives an estimated impact report showing how
              their group has performed.
            </li>
            <li>
              Organisation admins can also generate aggregate reports to see the combined results for all certified
              labs within their organisation.
            </li>
          </ul>
        </div>

        <div className="flex justify-center">
          <img src={impactReportSvg}
               alt="Impact Estimate Reports visualization showing lab performance and organization-wide sustainability results"
               className="max-w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
}
